/**
 * Coded (flag) value sets for IMITEMDP, transcribed from the Delphi DFM uWMM0003.dfm.
 *
 * Declared here once and shared by the grid <Lookup> columns in List.js, the search-panel selects
 * in the accordion, and the Setup tab's selects. The sibling screens (weekSettings, exceptions)
 * each duplicate their option array across List.js and their tab component, which is how the two
 * copies drift apart.
 *
 * The `{ id, text }` shape suits both consumers: DataGrid <Lookup valueExpr="id" displayExpr="text">
 * and loadLookupFromStaticDataSource(..., 'id', 'text').
 */

/** Stored codes, so nothing downstream repeats a bare 'N' / 'Y' / 'A' / 'O' literal. */
export const STORAGE_START_DATE = {
    CURRENT_DATE: 'N',
    ACTUAL_RECEIPT_DATE: 'Y',
    ORIGINAL_INVENTORY: 'O',
};

export const RESTART_STORAGE_DATES = {
    NO: 'N',
    WHEN_AVAILABLE_ZERO_OR_LESS: 'A',
};

export const EXP_DATE_BASED_ON = {
    NONE: 'N',
    RECEIPT_SHIP_DATE: 'A',
};

export const RATE_SCHEDULE_FILTER = {
    NO_FILTER: 'N',
    ACTIVE_ONLY: 'A',
};

/** Ownership Transfer > Start Date (STORAGESTARTDATE). */
export const storageStartDateOptions = [
    { id: STORAGE_START_DATE.CURRENT_DATE, text: 'Default from current date' },
    { id: STORAGE_START_DATE.ACTUAL_RECEIPT_DATE, text: 'Default from actual receipt date' },
    { id: STORAGE_START_DATE.ORIGINAL_INVENTORY, text: 'Default from original inventory code' },
];

/** Duplicate Lots - Storage Begin/End Dates > Re-Initialize (RESTARTSTORAGEDATES). */
export const restartStorageDatesOptions = [
    { id: RESTART_STORAGE_DATES.NO, text: 'No' },
    { id: RESTART_STORAGE_DATES.WHEN_AVAILABLE_ZERO_OR_LESS, text: 'When Available Quantity <= 0' },
];

/** Expiration date generation > Based on (EXPDATEBASEDON). */
export const expDateBasedOnOptions = [
    { id: EXP_DATE_BASED_ON.NONE, text: 'None' },
    { id: EXP_DATE_BASED_ON.RECEIPT_SHIP_DATE, text: 'Received/Ship date of the Receipt' },
];

/** Rate Schedule > Rate Sch Filter (RATESCHEDULEFILTER). */
export const rateScheduleFilterOptions = [
    { id: RATE_SCHEDULE_FILTER.NO_FILTER, text: 'No filter' },
    { id: RATE_SCHEDULE_FILTER.ACTIVE_ONLY, text: 'Active only' },
];

/**
 * uWMM0003.qryIMItemDPAfterInsert - the values the Delphi screen seeds on a new record. The server
 * applies the same defaults in ItemDataProfileService.ApplyDefaults, so a direct API call gets them
 * too; these are here so the Add form shows them before the first save.
 */
export const NEW_RECORD_DEFAULTS = {
    STORAGESTARTDATE: STORAGE_START_DATE.ACTUAL_RECEIPT_DATE,
    RESTARTSTORAGEDATES: RESTART_STORAGE_DATES.NO,
    EXPDATEBASEDON: EXP_DATE_BASED_ON.NONE,
    RATESCHEDULEFILTER: RATE_SCHEDULE_FILTER.NO_FILTER,
};
